import React from 'react';
import classNames from 'classnames';
import { Enterprise } from 'models/Enterprises';
import BrandingForm from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Branding/components/BrandingForm';

import './EnterpriseBrandingWrapper.styles.scss';
import './EnterpriseBrandingWrapper.styles.responsive.scss';

type EnterpriseBrandingWrapperProps = {
  className?: string;
  enterprise: Enterprise;
  updateEnterprise: (enterprise: Partial<Enterprise>) => void;
};

const EnterpriseBrandingWrapper: React.FC<EnterpriseBrandingWrapperProps> = (
  props,
) => {
  const { className, enterprise, updateEnterprise } = props;

  const classes = classNames('enterprise-branding-wrapper', className);

  return (
    <div className={classes}>
      <BrandingForm
        enterprise={enterprise}
        updateEnterprise={updateEnterprise}
      />
    </div>
  );
};

export default EnterpriseBrandingWrapper;
